import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { toast } from 'react-toastify';

import { catalogAPI } from '../../api/catalogAPI'
import { tableOrderAPI } from '../../api/tableOrderAPI';
import { roomAPI } from '../../api/roomAPI';

import SaveIcon from '../../assets/images/save.png';
import RefeshIcon from '../../assets/images/refresh.png';
import BackIcon from '../../assets/images/back.png';
import FoodIcon from '../../assets/images/food.png';
import BeverageIcon from '../../assets/images/beverages.png';
import SubCategoryIcon from '../../assets/images/subcategories.png';

import ItemSearch from '../../components/itemSearch';
import GuestSeach from '../../components/guestSearch';
import RoomSearch from '../../components/roomSearch';

import Spinner from "../../components/spinner/spinner";
import FullScreenSpinner from '../../components/fullScreenSpinner';

import './posTouch.css';

export default function POSTouch() {
    const Location = useLocation();
    const { selectedTableNo, selectedRoomNo, backNavigationPath, selectedMode, selectedLocCode } = Location.state;

    const [subCategories, setSubCategoris] = useState([]);
    const [items, setItems] = useState([]);

    const didMount = useRef(false);

    const [isProcessingCatalog, setIsProcessingCatalog] = useState(true)
    const [isShowFullScreenSpinner, setIsShowFullScreenSpinner] = useState(false);

    const [isNewOrder, setIsNewOrder] = useState(true);

    const [tableNo, setTableNo] = useState(selectedTableNo);
    const [subTableNo, setSubTableNo] = useState('1');
    const [roomNo, setRoomNo] = useState(selectedRoomNo);
    const [locCode, setLocCode] = useState(selectedLocCode);
    const [pax, setPax] = useState(0);
    const [cusCode, setCusCode] = useState("");
    const [cusName, setCusName] = useState("");

    const [defCusCode, setDefCusCode] = useState("");
    const [defCusName, setDefCusName] = useState("");
    const [defTableOrderDate, setDefTableOrderDate] = useState("");

    const [occupyNo, setOccupyNo] = useState('');
    const [fromPCode, setFromPCode] = useState('');

    const [itemCode, setItemCode] = useState('');
    const [itemDesc, setItemDesc] = useState('');
    const [itemQty, setItemQty] = useState(1);
    const [itemPrice, setItemPrice] = useState(0);
    const [itemExpTime, setItemExpTime] = useState('');
    const [itemRemarks, setItemRemarks] = useState('');
    const [itemTotal, setItemTotal] = useState(0);

    const [voidItemCode, setVoidItemCode] = useState('');
    const [voidItemDesc, setVoidItemDesc] = useState('');
    const [voidInvoicedItemQty, setVoidInvoicedItemQty] = useState(1);
    const [voidItemQty, setVoidItemQty] = useState(1);
    const [voidItemPrice, setVoidItemPrice] = useState(0);
    const [voidReason, setVoidReason] = useState('');
    const [voidKOTBOTNo, setVoidKOTBOTNo] = useState('');

    const [addedNewItems, setAddedNewItems] = useState([]);
    const [invoicedItems, setInvoicedItems] = useState([]);

    const [grandTotal, setGrandTotal] = useState(0);

    const [discRate, setDiscRate] = useState(0);

    const [scRate, setScRate] = useState(0);
    const [defScRate, setDefScRate] = useState(0);

    const [tdlRate, setTdlRate] = useState(0);
    const [defTdlRate, setDefTdlRate] = useState(0);

    const [nbtRate, setNbtRate] = useState(0);
    const [defNbtRate, setDefNbtRate] = useState(0);

    const [vatRate, setVatRate] = useState(0);
    const [defVatRate, setDefVatRate] = useState(0);

    const [tableOrderNo, setTableOrderNo] = useState("");
    const [tableOrderDate, setTableOrderDate] = useState("");

    const [remarks, setRemarks] = useState('');

    useEffect(() => {
        setGrandTotal(calGrandTotal);
    }, [addedNewItems, invoicedItems])

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            geTableOrderDetails();
            getSubCategories();
        }
    }, []);

    const discAmt = +((grandTotal * discRate) / 100).toFixed(2);
    const scAmt = +(((grandTotal - discAmt) * scRate) / 100).toFixed(2);
    const tdlAmt = +(((grandTotal - discAmt) * tdlRate) / 100).toFixed(2);
    const nbtAmt = +(((grandTotal - discAmt + tdlAmt) * nbtRate) / 100).toFixed(2);
    const vatAmt = +(((grandTotal - discAmt + scAmt + tdlAmt + nbtAmt) * vatRate) / 100).toFixed(2);

    const netTotal = (grandTotal - discAmt + scAmt + tdlAmt + nbtAmt + vatAmt).toFixed(2);

    const calGrandTotal = () => {
        let newItemTotal = addedNewItems.reduce((prev, current) => {
            return prev + (+(current.itemQty * current.itemPrice).toFixed(2));
        }, 0);

        let invoicedItemTotal = invoicedItems.reduce((prev, current) => {
            return prev + current.unitTotal;
        }, 0);

        return newItemTotal + invoicedItemTotal;
    }

    const geTableOrderDetails = () => {

        setIsShowFullScreenSpinner(true);

        setAddedNewItems([]);

        tableOrderAPI.getTableOrder(tableNo, subTableNo, roomNo, locCode).then((data) => {
            if (data.mainDetails !== null) { // Existing invoice
                setIsNewOrder(false);
                setTableOrderNo(data.mainDetails.invNo);
                setTableOrderDate(data.mainDetails.invDate);
                setDefTableOrderDate(data.defTableOrderDate);
                setCusCode(data.mainDetails.cusCode);
                setCusName(data.mainDetails.cusName);
                setOccupyNo(data.mainDetails.occupyNo);
                setFromPCode(data.mainDetails.fromPCode);
                setRoomNo(data.mainDetails.roomNo);
                setLocCode('');
                setPax(data.mainDetails.pax);
                setLocCode(data.mainDetails.locCode);

                setDefCusCode(data.defCusCode);
                setDefCusName(data.defCusName);

                setInvoicedItems(data.items);

                setDiscRate(data.mainDetails.discRate);
                setScRate(data.mainDetails.scRate);
                setTdlRate(data.mainDetails.tdlRate);
                setNbtRate(data.mainDetails.nbtRate);
                setVatRate(data.mainDetails.taxRate);

                setDefScRate(data.defScRate);
                setDefTdlRate(data.defTdlRate);
                setDefNbtRate(data.defNbtRate);
                setDefVatRate(data.defVatRate);

                setRemarks(data.mainDetails.remarks);
            }
            else { // new invoice
                setIsNewOrder(true);
                setTableOrderNo(data.nextTableOrderNo);
                setDefTableOrderDate(data.tableOrderDate);
                setTableOrderDate(data.tableOrderDate);
                setCusCode(data.cusCode);
                setCusName(data.cusName);

                setDefCusCode(data.cusCode);
                setDefCusName(data.cusName);
                setOccupyNo('');
                setFromPCode('');

                setScRate(data.scRate);
                setTdlRate(data.tdlRate);
                setNbtRate(data.nbtRate);
                setVatRate(data.vatRate);

                setDefScRate(data.scRate);
                setDefTdlRate(data.tdlRate);
                setDefNbtRate(data.nbtRate);
                setDefVatRate(data.vatRate);

                if (tableNo.trim().length === 0 && roomNo.trim().length !== 0)
                    getRoomOccupy();    
            }
        }).finally(() => setIsShowFullScreenSpinner(false));
    }

    const getSubCategories = (isFood = false, isBeverages = false) => {
        setIsProcessingCatalog(true);

        setItems([]);

        catalogAPI.getSubCategories(isFood, isBeverages).then((data) => setSubCategoris(data)).finally(() => setIsProcessingCatalog(false));
    }

    const getItems = (subCatCode = '') => {
        setIsProcessingCatalog(true);

        setSubCategoris([]);
        catalogAPI.getItems(subCatCode).then((data) => setItems(data)).finally(() => setIsProcessingCatalog(false));
    }

    const setItemModalVal = (itemCode, itemDesc, sellPrice) => {
        setItemCode(itemCode);
        setItemDesc(itemDesc);
        setItemPrice((+sellPrice).toFixed(2));
        setItemQty(1);
        setItemExpTime('');
        setItemRemarks('');

        setItemTotal((+sellPrice).toFixed(2));
    }

    const setVoidItemModal = (itemCode, itemDesc, qty, sellPrice, kotbotNo) => {
        setVoidItemCode(itemCode);
        setVoidItemDesc(itemDesc);
        setVoidItemQty(qty);
        setVoidInvoicedItemQty(qty);
        setVoidItemPrice(sellPrice);
        setVoidReason('');
        setVoidKOTBOTNo(kotbotNo);
    }

    const addToGrid = () => {
        if (itemCode.trim().length === 0 || itemDesc.trim().length === 0) { toast.warn("Item not found, please select the item again"); return; }
        if (+itemQty <= 0) { toast.warn("Please enter qty"); return; }
        if (!Number.isInteger(+itemQty)) { toast.warn("Qty must be a whole number"); return; }

        setAddedNewItems(prevArray => [...prevArray, { itemCode, itemDesc, itemQty, itemPrice, itemExpTime, itemRemarks }]);

        document.getElementById("modalPOSItems_Close").click();
    }

    const removeFromGrid = (index) => {
        setAddedNewItems(prevArray => {
            const newArray = [...prevArray];
            newArray.splice(index, 1);
            return newArray;
        });
    }

    const onChangeItemQty = (qty) => {
        setItemQty(qty);

        calItemModalPrice(qty);
    }

    const calItemModalPrice = (qty) => {
        setItemTotal((+qty * +itemPrice).toFixed(2));
    }

    const saveBill = () => {
        if (tableOrderDate.length === 0) { toast.warn("Date not found, please refresh the page"); return }
        if (tableNo.trim().length === 0 && roomNo.trim().length === 0) { toast.warn("Please enter table / room #"); return; }
        if (cusCode.trim().length === 0 || cusName.trim().length === 0) { toast.warn("Please select guest details"); return; }
        if (pax.length === 0) { toast.warn("Please enter pax."); return; }
        if (addedNewItems.length === 0) { toast.warn("Please enter items"); return; }

        if (discRate.length === 0 || isNaN(discRate)) { toast.warn("Invalid discount percentage"); return; }

        if (window.confirm("Do you want to save ?") === false) return;

        setIsShowFullScreenSpinner(true);

        tableOrderAPI.saveTableOrder(tableOrderNo, tableOrderDate, tableNo, subTableNo, roomNo, addedNewItems, grandTotal, discRate, scRate,
            tdlRate, nbtRate, vatRate, netTotal, isNewOrder, cusCode, cusName, occupyNo, pax, remarks, locCode, fromPCode).then((data) => {
                toast.success(`Successfully Saved. Invoice # ${data}`);

                clearForm();
                goBack();
            }).finally(() => setIsShowFullScreenSpinner(false));
    }

    const clearForm = () => {
        setIsNewOrder(true);

        setAddedNewItems([]);
        setInvoicedItems([]);

        setCusCode(defCusCode);
        setCusName(defCusName);

        setTableNo('');
        setSubTableNo('');
        setRoomNo('');
        setLocCode('');
        setPax(0);

        setItemCode('');
        setItemDesc('');
        setItemQty(1);
        setItemPrice(0);
        setItemExpTime('');
        setItemRemarks('');
        setItemTotal(0);

        setGrandTotal(0);

        setDiscRate(0);
        setScRate(defScRate);
        setTdlRate(defTdlRate);
        setNbtRate(defNbtRate);
        setVatRate(defVatRate);

        setTableOrderDate(defTableOrderDate);
        getNextTableOrderNo();
        setOccupyNo('');
        setFromPCode('');
        setRemarks('');
    }

    const goBack = () => {
        document.getElementById("goback__PosTouch").click();
    }

    const onChangeTableNo = (tableNo) => {
        setTableNo(tableNo);

        clearInvoiceDetails();
    }

    const onChangeSubTableNo = (subTableNo) => {
        setSubTableNo(subTableNo);

        clearInvoiceDetails();
    }

    const clearInvoiceDetails = () => {
        setTableOrderNo("");
        setTableOrderDate(defTableOrderDate);

        setPax(0);
        setRoomNo("");
        setOccupyNo('');
        setFromPCode('');
        setLocCode('');

        setAddedNewItems([]);
        setInvoicedItems([]);

        setCusCode(defCusCode);
        setCusName(defCusName);

        setDiscRate(0);
        setScRate(defScRate);
        setTdlRate(defTdlRate);
        setNbtRate(defNbtRate);
        setVatRate(defVatRate);

        setRemarks('');
    }

    const getNextTableOrderNo = () => {
        tableOrderAPI.getNextTabelOrderNo().then((data) => setTableOrderNo(data));
    }

    const onChangeRoomNo = (roomNo) => {
        setRoomNo(roomNo);

        setOccupyNo('');
        setFromPCode('');
    }

    const getRoomOccupy = () => {
        roomAPI.getRoomOccupy(roomNo).then((data) => {
            setOccupyNo(data.mainDetails.occupyNo);
            setCusCode(data.mainDetails.cusCode);
            setCusName(data.mainDetails.cusName);
            setFromPCode(data.mainDetails.fromPCode);
        }).catch((data) => {
            setRoomNo("");
            setOccupyNo("");

            toast.warn(data);
        });
    }

    const voidItem = () => {
        if (tableOrderNo.trim().length === 0) { toast.warn("Invoice not found, please refresh the page"); return; }

        if (voidItemCode.trim().length === 0 || voidItemDesc.trim().length === 0) { toast.warn("Please select an item"); return; }

        if (voidItemQty <= 0) { toast.warn("Please enter void qty"); return; }

        if (!Number.isInteger(+voidItemQty)) { toast.warn("Qty must be a whole number"); return; }

        if (voidReason.trim().length === 0) { toast.warn("Please enter void reason"); return; }

        if (voidKOTBOTNo.trim().length === 0) { toast.warn("KOT / BOT # not found"); return; }

        if (window.confirm("Do you want to void ?") === false) return;

        setIsShowFullScreenSpinner(true);

        tableOrderAPI.voidTableOrderItem(tableOrderNo, voidItemCode, voidItemDesc, (voidItemQty * -1), voidItemPrice, voidReason, voidKOTBOTNo).
            then((data) => {
                document.getElementById("modalPOSItemsVoid_Close").click();
                clearVoidItems();
                toast.success("Successfully saved.");
                geTableOrderDetails();
            }).finally(() => setIsShowFullScreenSpinner(false));
    }

    const clearVoidItems = () => {
        setVoidItemCode('');
        setVoidItemDesc('');
        setVoidItemQty(1);
        setVoidItemPrice(0);
        setVoidReason('');
        setVoidKOTBOTNo('');
        setVoidInvoicedItemQty(0);
    }

    return (
        <>
            {isShowFullScreenSpinner === true && <FullScreenSpinner />}
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 posTouch__content">
                    <div className="row posTouch__header">
                        <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 text-start ps-3">
                            <label>fitPOS</label>
                            <label className="ms-5">{tableOrderDate}</label>
                            <label className="ms-5">{tableOrderNo}</label>
                            <label className="ms-5">Guest : {cusName}</label>
                        </div>
                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-end pe-3">
                            Mode : {selectedMode}
                        </div>
                    </div>
                    <div className="row mt-0 p-2 pt-0">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="row mt-2">
                                <div className="col-4 col-sm-3 col-md-4 col-lg-4 col-xl-4 col-xxl-4 pe-0">
                                    <button className="btn btn-primary form-control" onClick={() => getSubCategories()}>
                                        All
                                        <img src={SubCategoryIcon} alt="" className="ms-1 d-none d-lg-inline d-xl-inline d-xxl-inline" />
                                    </button>
                                </div>
                                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 pe-0">
                                    <button className="btn btn-primary form-control" onClick={() => getSubCategories(true, false)}>
                                        Food
                                        <img src={FoodIcon} alt="" className="ms-1 d-none d-lg-inline d-xl-inline d-xxl-inline" />
                                    </button>
                                </div>
                                <div className="col-4 col-sm-5 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                    <button className="btn btn-primary form-control" onClick={() => getSubCategories(false, true)}>
                                        Beverages
                                        <img src={BeverageIcon} alt="" className="ms-1 d-none d-lg-inline d-xl-inline d-xxl-inline" />
                                    </button>
                                </div>
                            </div>
                            <div className="row mt-1 posTouch__items--root">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 posTouch__items--content">
                                    {isProcessingCatalog === true && <div className="text-center"><Spinner /></div>}
                                    {
                                        subCategories.map((data) => (
                                            <div className="card postTouch__items--card pb-0" key={data.cat2Code}
                                                onClick={() => getItems(data.cat2Code)}>
                                                <div className="card-body p-0 text-center">
                                                    <p className="card-title p-0 m-0">{data.cat2Name}</p>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    {
                                        items.map((data) => (
                                            <div className="card postTouch__items--card pb-0" key={data.itemCode}
                                                onClick={() => setItemModalVal(data.itemCode, data.itemDesc, data.sellPrice)}
                                                data-bs-toggle="modal" data-bs-target="#modalPOSItems">
                                                <div className="card-body p-0 text-center">
                                                    <p className="card-title p-0 m-0">{data.itemDesc}</p>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="row">
                                <div className="col-4 col-sm-3 col-md-3 col-lg-3 col-xl-4 col-xxl-4">
                                    Table #
                                </div>
                                <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                    Sub Table #
                                </div>
                                <div className="col-4 col-sm-2 col-md-3 col-lg-3 col-xl-4 col-xxl-4">
                                    Room <span className="small">{occupyNo.trim().length !== 0 && `(Occupy # ${occupyNo})`}</span>
                                </div>
                                <div className="col-4 col-sm-3 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                    Pax.
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 col-sm-3 col-md-3 col-lg-3 col-xl-4 col-xxl-4 pe-0">
                                    <input type="text" className="form-control" value={tableNo} onChange={(e) => onChangeTableNo(e.target.value)}
                                        readOnly={selectedMode.startsWith("Steward") ? false : true} onBlur={() => geTableOrderDetails()} maxLength="5" />
                                </div>
                                <div className="col-2 col-sm-3 col-md-3 col-lg-3 col-xl-2 col-xxl-2 pe-0">
                                    <input type="text" className="form-control" value={subTableNo}
                                        onChange={(e) => onChangeSubTableNo(e.target.value)}
                                        readOnly={selectedMode.startsWith("Steward") ? false : true} onBlur={() => geTableOrderDetails()} maxLength="5"/>
                                </div>
                                { /* do not allow room number to be selected by typing but it should be via the roomSeacrh modal as inter property rooms can be selected */ }
                                <div className="col-4 col-sm-3 col-md-3 col-lg-3 col-xl-4 col-xxl-4 pe-0">
                                    <input type="text" className="form-control" value={roomNo} disabled={true} />
                                </div>
                                <div className="col-2 col-sm-3 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                    <input type="number" className="form-control" value={pax}
                                        onChange={(e) => setPax(e.target.value)} />
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 posTouch__items--table">
                                    <table class="table table-hover">
                                        <thead className="thead--color">
                                            <tr>
                                                <td>Item</td>
                                                <td className="text-end">Qty</td>
                                                <td className="text-end">Price</td>
                                                <td className="text-end">Total</td>
                                                <td className="text-center">
                                                    Action
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                addedNewItems.map((data, index) => (
                                                    <tr key={index} className="text-success">
                                                        <td>{data.itemDesc}</td>
                                                        <td className="text-end">{(+data.itemQty).toFixed(2)}</td>
                                                        <td className="text-end">{(+data.itemPrice).toFixed(2)}</td>
                                                        <td className="text-end">{(data.itemQty * data.itemPrice).toFixed(2)}</td>
                                                        <td className="text-center">
                                                            <button type="button" onClick={() => removeFromGrid(index)}
                                                                className="btn btn-sm btn-danger">
                                                                X
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                            {
                                                invoicedItems.map((data, index) => (
                                                    <tr key={index} className="text-danger">
                                                        <td>{data.itemDesc}</td>
                                                        <td className="text-end">{(+data.qty).toFixed(2)}</td>
                                                        <td className="text-end">{(+data.sellPrice).toFixed(2)}</td>
                                                        <td className="text-end">{(+data.unitTotal).toFixed(2)}</td>
                                                        <td className="text-center">
                                                            {
                                                                data.isComplete === true  ? "Completed" 
                                                                    :
                                                                    (
                                                                        +data.qty < 0 ? "N/A" :
                                                                        <button type="button" onClick={() => setVoidItemModal(data.itemCode, data.itemDesc,
                                                                            data.qty, data.sellPrice, data.kotbotno)}
                                                                            data-bs-toggle="modal" data-bs-target="#modalPOSItemsVoid"
                                                                            className="btn btn-sm btn-danger small btn__void">
                                                                            Mark as Void
                                                                        </button>
                                                                    )
                                                            }
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                    Remarks
                                    <textarea value={remarks} onChange={(e) => setRemarks(e.target.value)} rows="2" className="form-control"
                                        maxLength="250">
                                    </textarea>
                                </div>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                    <div className="row">
                                        <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 fw-bold">Grand Total</div>
                                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-end fw-bold">
                                            {(+grandTotal).toFixed(2)}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5">Discount</div>
                                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                            {
                                                selectedMode.startsWith("Steward") ?
                                                    <input type="number" class="textField__posTotals text-end" value={discRate}
                                                        onChange={(e) => setDiscRate(e.target.value)} />
                                                    :
                                                    <input type="number" class="textField__posTotals text-end" value={discRate}
                                                        onChange={(e) => setDiscRate(e.target.value)} readOnly="true" />
                                            }
                                        </div>
                                        <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 text-end">
                                            {discAmt}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5">SC</div>
                                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                            <input type="number" class="textField__posTotals text-end" readOnly="true" value={scRate} />
                                        </div>
                                        <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 text-end">
                                            {scAmt}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5">TDL</div>
                                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                            <input type="number" class="textField__posTotals text-end" readOnly="true" value={tdlRate} />
                                        </div>
                                        <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 text-end">
                                            {tdlAmt}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5">NBT</div>
                                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                            <input type="number" class="textField__posTotals text-end" readOnly="true" value={nbtRate} />
                                        </div>
                                        <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 text-end">
                                            {nbtAmt}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5">VAT</div>
                                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                            <input type="number" class="textField__posTotals text-end" readOnly="true" value={vatRate} />
                                        </div>
                                        <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 text-end">
                                            {vatAmt}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 fw-bold">Total</div>
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 text-end fw-bold">
                                            {netTotal}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 px-2">
                                    <button className="btn btn-primary form-control" onClick={() => saveBill()}>
                                        Save
                                        <img src={SaveIcon} alt="" className="ms-1" />
                                    </button>
                                </div>
                                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 px-2">
                                    <button className="btn btn-secondary form-control" onClick={() => clearForm()}>
                                        Clear
                                        <img src={RefeshIcon} alt="" className="ms-1" />
                                    </button>
                                </div>
                                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 px-2">
                                    <Link to={backNavigationPath}>
                                        <button className="btn btn-danger form-control" id="goback__PosTouch">
                                            Back
                                            <img src={BackIcon} alt="" className="ms-1" />
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 px-2">
                                    <ItemSearch setItemCode={setItemCode} setItemDesc={setItemDesc} setItemQty={setItemQty}
                                        setItemPrice={setItemPrice} setItemRemarks={setItemRemarks} setItemExpTime={setItemExpTime}
                                        setItemTotal={setItemTotal} modalName="modalPOSItems" />
                                </div>
                                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 px-2">
                                    <GuestSeach setCusCode={setCusCode} setCusName={setCusName} />
                                </div>
                                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 px-2">
                                    <RoomSearch setRoomNo={setRoomNo} setOccupyNo={setOccupyNo} setCusCode={setCusCode}
                                        setCusName={setCusName} setFromPCode={setFromPCode} disabled={selectedMode.startsWith("Room") ? true : false}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modalPOSItems" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{itemDesc}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    Price
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <input type="text" className="form-control text-end text-danger fw-bold" value={itemPrice}
                                        readOnly="true" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    Qty
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <input type="number" className="form-control text-end text-danger fw-bold" value={itemQty}
                                        onChange={(e) => onChangeItemQty(e.target.value)} />
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12 text-center">
                                    <span className="text-danger fw-bold">Total {itemTotal}</span>
                                </div>
                            </div>
                            <div className="row pt-0 mt-0">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    Expected Time
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <input type="time" className="form-control text-center" value={itemExpTime}
                                        onChange={(e) => setItemExpTime(e.target.value)} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    Remarks
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <textarea className="form-control" value={itemRemarks} onChange={(e) => setItemRemarks(e.target.value)}
                                        maxLength="150" rows="2">
                                    </textarea>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <button className="btn btn-primary form-control" onClick={() => addToGrid()}>Add +</button>
                                    <button className="btn btn-danger form-control mt-1" data-bs-dismiss="modal" id="modalPOSItems_Close">
                                        Close X
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modalPOSItemsVoid" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h4 className="modal-title text-danger text-center">VOID</h4>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <h4>{voidItemDesc}</h4>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                    <span className="text-danger fw-bold">Price : {voidItemPrice}</span>
                                </div>
                                <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                    <span className="text-danger fw-bold">Invoiced Qty : {voidInvoicedItemQty}</span>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    Void Qty
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <input type="number" className="form-control text-end text-danger fw-bold" value={voidItemQty}
                                        onChange={(e) => setVoidItemQty(e.target.value)} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    Reason
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <textarea className="form-control" value={voidReason} onChange={(e) => setVoidReason(e.target.value)}
                                        maxLength="150" rows="2">
                                    </textarea>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <button className="btn btn-danger form-control" onClick={() => voidItem()}>Void</button>
                                    <button className="btn btn-secondary form-control mt-1" data-bs-dismiss="modal" id="modalPOSItemsVoid_Close">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}